/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalQuestionDataSubtypeSchema = z.enum(['name', 'email', 'phone', 'multiple'])

export type AdditionalQuestionDataSubtypeSchema = z.infer<typeof additionalQuestionDataSubtypeSchema>
